import React from "react";
import Pagination from "../pagination/Pagination";
import ReviewCardWithoutReply from "../review card/ReviewCardWithoutReply";

const VendorReviewsContainer = () => {
  return (
    <div>
      <div className="bg-sectionBg-900 px-2 py-3">
        <h2 className="text-textSecondary-900 lg:text-lg">
          Reviews from Customar
        </h2>
      </div>
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />
      <ReviewCardWithoutReply
        image="https://images.pexels.com/photos/2119095/pexels-photo-2119095.jpeg?auto=compress&cs=tinysrgb&w=1600"
        name="Sujana Begum"
      />

      <Pagination />
    </div>
  );
};

export default VendorReviewsContainer;
